import { useMediaQuery } from "react-responsive"

const FooterImagesSlider = (props) => {

    const {images} = props

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    return (

        <section className={isMobile ? "flex col footer-section-mobile" : "flex col footer-section"}>
            <h2 className="footer-title ">Ya confían en nosotros</h2>
            <section className="flex jcenter logos-slider">
                <section className="logos-wrapper">

                    {Array.from({ length: 2 }).map((_, repeatIndex) =>
                        images.map((num, i) => (
                            <img loading="lazy" alt="Imagen" key={`${repeatIndex}-${i}`} src={`/images/institutions/${num}.png`} />
                        ))
                    )}

                </section>
            </section>
        </section>

    )

}

export default FooterImagesSlider